import {
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Component({
  selector: 'layout-fragments-render',
  templateUrl: './layout-fragments-render.component.html',
  styleUrls: ['./layout-fragments-render.component.scss']
})
export class LayoutFragmentsRenderComponent implements OnInit {

  @Input() public layout: IdtComponent | undefined;

  @HostBinding('style.background-color')
  public backgroundColor: string | undefined;

  public ngOnInit() {
    if (isDefined(this.layout) && isDefined(this.layout.settings)) {
      this.backgroundColor = this.layout.settings.styles && this.layout.settings.styles.bgColor;
    }
  }

}
